import { kea } from 'kea'

import homeSceneLogic from '~/scenes/homepage/logic'

export default kea({
  path: () => ['scenes', 'homepage', 'photoArea'],

  connect: {
    actions: [homeSceneLogic, ['showHow']],
    props: [homeSceneLogic, ['covers', 'coverPhoto', 'coverPhotoData', 'categorySuggestions']]
  }
})
